import { Clock, Lightning, UsersFour, Wallet } from '@phosphor-icons/react';
import { ReferralMetrics } from '../../../../../../types/apiTypes';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';

function ReferralMetricsWidget({
  referralMetrics,
}: {
  referralMetrics: ReferralMetrics | null;
}) {
  const { screenView } = useScreenView();

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="flex w-[100%] items-center justify-center gap-4 align-middle sm:flex-col lg:flex-row">
            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[276px]">
              {/* <div className="absolute right-2 top-2 rounded-[8px] border-[1px] border-accent px-[6px] py-[1px]">
                <p className="text-accent opacity-[100%]">Coming Soon!</p>
              </div> */}
              <div className="max-w-[30%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px]">
                <Wallet size={24} className="justify-center" />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle">
                <h2 className="text-[14px] text-[#0A112F]">
                  Payout This Month
                </h2>
                <div className="flex flex-row items-end">
                  <h1 className="text-[30px] font-[700] leading-[40px] text-primary">
                    ${Math.floor(referralMetrics?.monthlyReferralPayout ?? 0)}
                  </h1>
                  <span className="text-[26px] text-graysecondary">
                    .
                    {
                      String(
                        (referralMetrics?.monthlyReferralPayout ?? 0).toFixed(2)
                      ).split('.')[1]
                    }
                  </span>
                </div>
              </div>
            </div>

            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[276px]">
              {/* <div className="absolute right-2 top-2 rounded-[8px] border-[1px] border-accent px-[6px] py-[1px]">
                <p className="text-accent opacity-[100%]">Coming Soon!</p>
              </div> */}
              <div className="max-w-[30%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px]">
                <UsersFour size={24} />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle">
                <h2 className="text-[14px] text-[#0A112F]">Active Referrals</h2>
                <h1 className="text-[30px] font-[700] leading-[40px] text-primary">
                  {referralMetrics?.activeReferralCount?.toString()}
                </h1>
              </div>
            </div>

            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[276px]">
              {/* <div className="absolute right-2 top-2 rounded-[8px] border-[1px] border-accent px-[6px] py-[1px]">
                <p className="text-accent opacity-[100%]">Coming Soon!</p>
              </div> */}
              <div className="max-w-[30%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px]">
                <Lightning size={24} />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle">
                <h2 className="text-[14px] text-[#0A112F]">
                  Activated This Month
                </h2>
                <h1 className="text-[30px] font-[700] leading-[40px] text-[#1D213B]">
                  {referralMetrics?.activatedThisMonth?.toString()}
                </h1>
              </div>
            </div>
            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[276px]">
              <div className="max-w-[30%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px]">
                <Clock size={24} />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle">
                <h2 className="text-[14px] text-[#0A112F]">Pending</h2>
                <h1 className="text-[30px] font-[700] leading-[40px] text-[#1D213B]">
                  {referralMetrics?.pendingCount?.toString()}
                </h1>
              </div>
            </div>
          </div>
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default ReferralMetricsWidget;
